import React from "react";

import Card from "./Card";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import ContentGrid from "../../../components/ContentGrid";

import style from "./style.module.css";

export default function BookCard (props) {
    const {
        items = [],
        book_card_title = "",
    } = props;

    return (
        <Section className={style.bookCard}>
            <div className={style.bookCardWrap}>
                {
                    book_card_title !== "" && (
                        <>
                            <Title 
                                transform="uppercase" 
                                tag="h4" 
                                className="fontTeko"
                            >
                                {book_card_title}
                            </Title>
                            <Spacer size={24} />
                        </>
                    )
                }
                {
                    items.length > 0 && (
                        <div className={style.colRow}>
                            <ContentGrid
                                col="col3"
                                wrap={1}
                                items={items}
                                Component={Card}
                            />
                        </div>
                    )
                }
            </div>
        </Section>
    )
}